import React, { useState, useMemo } from "react";

import "react-phone-number-input/style.css";
import PhoneInput, {
  formatPhoneNumberIntl,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import { InputAdornment, TextField } from "@mui/material";

function CountrySelector() {
  const [valuephone, setValuephone] = useState();
  const [currentCountry, setCurrentCountry] = useState(
    getCountryCallingCode("IN")
  );

  const handlechange = (value: any) => {
    const phone = `+${currentCountry}${value.target.value}`;
    setValuephone(value.target.value);

    console.log("Is valid phone number:", isValidPhoneNumber(phone));
    console.log("formatPhoneNumberIntl", formatPhoneNumberIntl(phone));
  };
  const handleCountryChange = (data: any) => {
    console.log("handleCountryChange", data);
    if (data) {
      const countryCode = getCountryCallingCode(data);

      console.log("ISD Code:", countryCode);
      setCurrentCountry(countryCode);
    }
  };

  const handlechangeinput = () => {};

  return (
    <div style={{ display: "flex", gap: "10px", margin: "20px" }}>
      <PhoneInput
        style={{ display: "flex" }}
        placeholder="Enter phone number"
        defaultCountry={"IN"}
        value={""}
        onChange={handlechangeinput}
        onCountryChange={handleCountryChange}
      />
      <div className="">
        <TextField
          label=""
          type="numeric"
          sx={{
            fieldset: { borderColor: "#007585" },
          }}
          placeholder="Enter Mobile Number"
          variant="outlined"
          value={valuephone}
          onChange={handlechange}
          inputProps={{
            sx: {
              "&::placeholder": {
                paddingLeft: "10px",
              },
              borderLeft: "1px solid #007585",
              paddingLeft: "10px",
            },
            // maxLength: 10,
            inputMode: "numeric",
            pattern: "[0-9 ]*",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                +{currentCountry}
              </InputAdornment>
            ),
          }}
          onKeyPress={(event) => {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const isValidKey = /^\d+$/.test(keyValue);

            if (!isValidKey) {
              event.preventDefault();
            }
          }}
        />
      </div>
    </div>
  );
}

export default CountrySelector;
